import { render } from "./FurnitureGarden.vue?vue&type=template&id=01ebf9fa"
import script from "./FurnitureGarden.vue?vue&type=script&lang=js"
export * from "./FurnitureGarden.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__